exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".retroShadow{color:#2c2c2c;letter-spacing:.05em;text-shadow:1px 1px 0 #d5d5d5,2px 2px 0 rgba(0,0,0,.1);text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/PieChart.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/PieChart.scss
// module chunks = 0